import { useCallback } from "react";
import { useAppContext } from "./useAppContext";
import { LisStatus } from "../../@types";
import { logError } from "../errors";

export const useLis = () => {
  // * Context
  const {
    state: { futureLis, lis },
  } = useAppContext();

  const getLisForYear = useCallback(
    (year: number) => {
      // ! can this be improved? timezones around new year could be inaccurate
      const currentCalendarYear = new Date().getUTCFullYear();
      switch (year) {
        // @TODO - think we may need to also look at `beneficiary.future_lis_status_start_date`
        // for everything to be entirely accurate from this hook
        case currentCalendarYear: {
          return lis || LisStatus.NoHelp;
        }
        case currentCalendarYear + 1: {
          // use current `lis` for an anon user that does not have `futureLis`
          return futureLis || lis || LisStatus.NoHelp;
        }
        default: {
          const err = new Error(
            `We have attempted to call getLisForYear for a year (${year}) other than the current (${currentCalendarYear}) or next (${
              currentCalendarYear + 1
            }) plan year.`
          );
          logError(err.message, err);
          return lis || LisStatus.NoHelp;
        } // we should never reach this.
      }
    },
    [futureLis, lis]
  );

  const isLis = !!(lis && lis !== LisStatus.NoHelp);
  const isFutureLis = !!(futureLis && futureLis !== LisStatus.NoHelp);

  return {
    lis,
    futureLis,
    /** function that returns `lis` for a given year
     * falls back to using `state.year` if not passed a year
     * falls back to returning `lis` if `futureLis` does not exist
     */
    getLisForYear,
    isLis,
    isFutureLis,
  };
};
